import type { FieldProps } from "@ui/components/forms/field/Field";
import { Field } from "@ui/components/forms/field/Field";
import { FormControl } from "@ui/components/forms/form-control/FormControl";
import { FormErrorMessage } from "@ui/components/forms/form-control/FormError";
import { FormLabel } from "@ui/components/forms/form-control/FormLabel";
import { Input } from "@ui/components/forms/input/Input";

import type { StyleProps } from "@ui/types";

type Props = {
    isInvalid: boolean;
    label: string;
    error: string;
    name: string;
    styles: {
        field: StyleProps;
        label: StyleProps;
        errorMessage: StyleProps;
        errorField: StyleProps;
    };
    fieldProps?: FieldProps;
    isDisabled?: boolean;
};

export const FooterInput = ({
    isDisabled,
    isInvalid,
    label,
    error,
    styles,
    name,
    fieldProps,
}: Props) => {
    return (
        <FormControl isDisabled={isDisabled} data-privacy="true" isRequired isInvalid={isInvalid}>
            <FormLabel {...styles.label}>{label}</FormLabel>

            <Field
                as={Input}
                name={name}
                type="text"
                {...styles.field}
                {...(isInvalid && styles.errorField)}
                {...(fieldProps ? fieldProps : {})}
            />
            <FormErrorMessage {...styles.errorMessage}>{error}</FormErrorMessage>
        </FormControl>
    );
};
